const getRouteWithBoxId = (path: string): string => {
  const boxId = Object.fromEntries(
    new URLSearchParams(window.location.search)
  ).box_id
  // eslint-disable-next-line i18next/no-literal-string
  return `${path}?box_id=${boxId}`
}

export default getRouteWithBoxId
